import React from 'react';
import PropTypes from 'prop-types';
import ModalWindow from '../../common/Modal';
import Button from '../../common/Button';
import styles from './AcceptInvitationModal.module.scss';

export function AcceptInvitationModal({ open = false, onClose, supplier, acceptInvitation }) {
  const accept = () => {
    const data = {
      supplier_id: supplier.id,
    };

    acceptInvitation && acceptInvitation(data);
    onClose();
  };

  return (
    <ModalWindow open={open} onClose={onClose} center>
      <h2>Accept invitation</h2>
      <hr />
      <div className={styles.body}>
        <p>You are about to accept an invitation from {supplier.name}.</p>
        <p>Once you accept, {supplier.name} will be requested to approve you.</p>
      </div>
      <hr />
      <div className={styles.footer}>
        <Button color="white" text="CANCEL" onClick={onClose} />
        <Button type="submit" text="ACCEPT" onClick={accept} />
      </div>
    </ModalWindow>
  );
}

AcceptInvitationModal.propTypes = {
  supplier: PropTypes.object.isRequired,
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  acceptInvitation: PropTypes.func.isRequired,
};
